export default __webpack_public_path__ + "static/media/BOD Special Meeting 13 April 2021.2e56ff09.pdf";